export interface Address {
    street?: string;
    locality?: string;
    dependentLocality?: string;
    region?: string;
    postalCode?: string;
    countryCode?: string;
}

export function createEmptyAddress(): Address {
    return {
        street: '',
        locality: '',
        dependentLocality: '',
        region: '',
        postalCode: '',
        countryCode: ''
    };
}
